export default function useStyles(withClearIcon) {
  return {
    label: {
      '& .MuiFormLabel-asterisk': {
        color: 'error.D10',
      },
    },
    select: (theme) => ({
      '& .MuiOutlinedInput-notchedOutline legend': {
        maxWidth: 'unset',
        ...theme.typography.label2,
        '> span': {
          p: '0 3px',
        },
      },
      '& .MuiSelect-select': {
        paddingLeft: 2,
      },
      '& .MuiSvgIcon-root': {
        right: 12,
        '&.Mui-disabled': {
          color: 'grey.L50',
        },
      },
      ...(withClearIcon && { pr: 0 }),
    }),

    clearIcon: {
      position: 'absolute',
      right: 0,
      pr: 2.125,
      pl: 0.5,
      display: 'none',
      ['.MuiInputBase-root:hover .MuiSelect-icon:not(.MuiSelect-iconOpen)~&,' +
      ' .MuiInputBase-root.Mui-focused .MuiSelect-icon:not(.MuiSelect-iconOpen)~&']: {
        display: 'flex',
      },
    },
    placeholder: {
      color: 'grey.L30',
    },
    menuItem: {
      whiteSpace: 'normal',
    },
  };
}
